import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { NotificationType } from '@app/shared/interfaces';
import { PropertiesService } from '@app/shared/services/properties/properties.service';
import { ToastNotificationsService } from '@app/shared/services/toast-notifications/toast-notifications.service';
import { CustomSitesService } from '../../services/custom-sites.service';

@Component({
  standalone: false,
  selector: 'sbnb-dialog-update-property-slug',
  templateUrl: './dialog-update-property-slug.component.html',
  styleUrls: ['./dialog-update-property-slug.component.scss'],
})
export class DialogUpdatePropertySlugComponent implements OnInit {
  saving: boolean;
  newSlug: string = '';

  constructor(
    private propertiesService: PropertiesService,
    private customSitesService: CustomSitesService,
    private toast: ToastNotificationsService,
    public dialogRef: MatDialogRef<DialogUpdatePropertySlugComponent>,
    @Inject(MAT_DIALOG_DATA)
    public dialogData: {
      property_id: number;
      site_id: string;
      slug: string;
      mode: 'site' | 'widget' | 'other';
    }
  ) { }

  ngOnInit(): void {
    this.newSlug = this.dialogData.slug;
  }

  updateSlug() {
    this.saving = true;
    this.propertiesService.updatePropertyDirectSlug(this.dialogData.property_id, this.newSlug).subscribe(
      (res) => {
        this.saving = false;
        this.dialogRef.close(this.newSlug);
      },
      (err) => {
        this.saving = false;
      }
    );
  }

  updateCustomSiteUrl() {
    this.saving = true;

    this.customSitesService
      .updateSitePropertyUrl(this.dialogData.site_id, this.dialogData.property_id, this.newSlug)
      .subscribe(
        (res) => {
          this.saving = false;
          this.dialogRef.close(this.newSlug);
        },
        (err) => {
          this.saving = false;
          let errorMessage = err.error?.message || 'There was an error updating the property URL';
          this.toast.open(
            errorMessage,
            'Dismiss',
            NotificationType.Error
          );
        }
      );
  }
}
